// local-server.service.ts
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserActivityService } from './user-activity.service';
import { WebApiConnectionService } from './database-cast/mongo/WebApiConnectionService';
import { LocalServerStatus } from '../_shared/models/LocalServerStatus';
import { LocalWebSocketService } from './local-websocket.service';

@Injectable({
  providedIn: 'root'
})
export class LocalServerService {

  private connectionStatusSubject = new BehaviorSubject<LocalServerStatus>(null);
  public connectionStatus$: Observable<LocalServerStatus> = this.connectionStatusSubject.asObservable();

  private _localServerStatus: LocalServerStatus = new LocalServerStatus();
  private _currentIp: string;
  private _clientCookieIdentifier: string;

  constructor(private userActivityService: UserActivityService, private webApiConnectionService: WebApiConnectionService,
      private localWs: LocalWebSocketService      
){
    this._clientCookieIdentifier = this.localWs.sessionId;   // <<--- sempre pronto
    this.startGuiClientReadyPolling();



  }

  getPublicIp(): Promise<string> {
    return fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => data.ip);
  }

  private startGuiClientReadyPolling() {


    setInterval(async () => {


      this.getPublicIp().then(ip => {

        this._currentIp = ip;
        this.webApiConnectionService.refreshLocalServerStatus(
          ip,
          this._clientCookieIdentifier,
          'userId',
          'userEmail'
        );



      });

      if (this.webApiConnectionService.localServerStatus != null) {
        if (this.webApiConnectionService.localServerStatus.LastChecked < new Date(new Date().getTime() - 5000)) //10 segundos
        {
          this._localServerStatus = new LocalServerStatus();
          this._localServerStatus.HasGui = false;
          this._localServerStatus.HasService = false;
          this._localServerStatus.LastChecked = new Date();


        }
        else {
          this._localServerStatus = this.webApiConnectionService.localServerStatus;
        }

        this.connectionStatusSubject.next(this._localServerStatus);
      }

    
  

    }, 3000); // a cada 3 segundos
  }


  public isWindows(): boolean {
    return navigator.userAgent.includes('Windows') || navigator.userAgent.includes('Win32') || navigator.userAgent.includes('Win64');
  }

  public sendPrintBet(message: any): void {

    this.webApiConnectionService.sendPrintBet(
      this._currentIp,
      this._clientCookieIdentifier,
      'userId',
      'userEmail',
      message
    );

  }
  //sendToLoteriasOnLine

  public sendToLoteriasOnLine(message: any): void {


    this.webApiConnectionService.sendToLoteriasOnLine(
      this._currentIp,
      this._clientCookieIdentifier,
      'userId',
      'userEmail',
      message
    );



  }



  public hasClientGuiReady() {
    return this._localServerStatus.HasGui;
  }

  public async updateClientGuiReady(): Promise<boolean> {

    return this._localServerStatus.HasGui;

  }


}
